export const TEST_CENTER_HOST: string = process.env.REACT_APP_IS_DEV === 'Y'
  ? 'https://devtestcenter.canb-english.com'
  : 'https://testcenter.canb-english.com';
